import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(
    new URLSearchParams(location.search).get('mode') !== 'signup'
  );
  const [formData, setFormData] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [localNotif, setLocalNotif] = useState(null);

  const { login, register, authNotif } = useAuth();
  const navigate = useNavigate();
  


  const showNotif = (message, type = 'success') => {
    setLocalNotif({ message, type });
    setTimeout(() => setLocalNotif(null), 5000);
  };

  // Affiche la notification de déconnexion si elle existe
  useEffect(() => {
    if (authNotif) {
      setLocalNotif(authNotif);
      setTimeout(() => setLocalNotif(null), 5000);
    }
  }, [authNotif]);

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation frontend
    if (!formData.email || !formData.password) {
      showNotif('Veuillez remplir tous les champs.', 'error');
      return;
    }
    if (!isLogin && !formData.name) {
      showNotif('Veuillez entrer votre nom complet.', 'error');
      return;
    }
    if (!isLogin && formData.password.length < 6) {
      showNotif('Le mot de passe doit contenir au moins 6 caractères.', 'error');
      return;
    }

    setLoading(true);
    try {
      if (isLogin) {
        const result = await login(formData.email, formData.password);
        showNotif(result.message || 'Connexion réussie ! Bienvenue.', 'success');
      } else {
        const result = await register(formData.name, formData.email, formData.password);
        showNotif(result.message || 'Compte créé avec succès ! Bienvenue.', 'success');
      }
      setTimeout(() => navigate('/dashboard'), 1000);
    } catch (err) {
      showNotif(err.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      {/* Toast notification */}
      {localNotif && (
        <div className={`login-toast login-toast-${localNotif.type}`}>
          <i className={`fas ${localNotif.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
          <span>{localNotif.message}</span>
          <button onClick={() => setLocalNotif(null)} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', marginLeft: '0.5rem' }}>
            <i className="fas fa-times"></i>
          </button>
        </div>
      )}

      <div className="login-container">
        <div className="login-left">
          <div className="login-brand">
            <div className="logo-icon">
              <i className="fas fa-file-pdf"></i>
            </div>
            <h1>PDF Generator Pro</h1>
            <p>Créez vos documents professionnels en quelques clics</p>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-container">
            <Link to="/" className="back-link">
              <i className="fas fa-arrow-left"></i> Retour à l'accueil
            </Link>

            <h2>{isLogin ? 'Connexion' : 'Créer un compte'}</h2>
            <p className="login-subtitle">
              {isLogin ? 'Accédez à votre espace de travail' : 'Commencez à créer vos documents'}
            </p>

            <form onSubmit={handleSubmit}>
              {!isLogin && (
                <div className="form-group">
                  <label className="form-label">Nom complet</label>
                  <input
                    type="text"
                    name="name"
                    className="form-input"
                    placeholder="Jean Dupont"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              )}
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="votre@email.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label className="form-label">Mot de passe</label>
                <input
                  type="password"
                  name="password"
                  className="form-input"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={handleChange}
                  minLength="6"
                />
              </div>

              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading
                  ? <><div className="spinner-small"></div> Chargement...</>
                  : <>{isLogin ? 'Se connecter' : "S'inscrire"} <i className="fas fa-arrow-right"></i></>
                }
              </button>
            </form>

            <div className="login-divider">
              <span>{isLogin ? "Vous n'avez pas de compte ?" : 'Vous avez déjà un compte ?'}</span>
            </div>

            <button className="btn btn-secondary btn-block" onClick={() => { setIsLogin(!isLogin); setLocalNotif(null); }}>
              {isLogin ? 'Créer un compte' : 'Se connecter'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;